import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import {
  CONSTANTS,
  COOKIE,
  SOCIAL_PERPAGE_LIMIT,
  VERTICALS,
} from "../../../constants/app-constant";
import {
  fileDownloadMethod,
  httpGet,
  httpPost,
} from "../../../utility/requestHelper";
// import { Button } from "../../../Shared/FormElements/Button";
import SocialFilters from "../Filters/SocialFilter";
import { getDateFormat } from "../../../utility/common-methods.jsx";
import { unifiedEnvConfig, envConfig } from "../../../constants/api-endpoint";
// import { FEED_DETAILS } from "../../../../constants/route-constants";
import DateRangeFilter from "../Filters/DateRangeFilter";
import { MenuIcon } from "../../Icons/icons.component.jsx";
import { useSelector } from "react-redux";
// import TopicWiseNewsContainer from "../PrintAndOnline/TopicWiseNewsContainer";
// import Loader from "../../../Shared/Loader";
import NoDataMessage from "../../Shared/NoDataMessage";
import "../Analysis/print.sass";
import ConceptLogo from "../../../assets/images/conceptbiu-logo.png";
import { SOCIAL_SOURCES_OPTIONS } from "../../../constants/static-filter";
import { TagsListModal } from "../TagsAndFavourites/Tags/TagsListModal";
import { getCookie, setCookie } from "../../../utility/cookieProvider";
// import styles from "../../Download.module.css";
// import DownloadPopup from "../../DownloadPopup";
import GifLoader from "../../Shared/LoaderGif";
import TopicWiseNewsContainer from "../News/PrintAndOnline/TopicWiseNewsContainer";

const { DATA_NOT_FOUND, EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } = CONSTANTS;

const { V_BLOG, V_FORUM } = VERTICALS;
const today = new Date();
const defaultValues = {
  def_fromDate: getDateFormat(today),
  def_toDate: getDateFormat(today),
  def_channelType: EMPTY_ARRAY,
  def_comments_count: 0,
  def_reaction_count: 0,
  def_city: EMPTY_STRING,
  def_tonality: EMPTY_ARRAY,
};

const {
  def_toDate,
  def_fromDate,
  def_reaction_count,
  def_tonality,
  def_channelType,
  def_city,
  def_comments_count,
} = defaultValues;

function DownloadReports({ data }) {
  const listContainerRef = useRef(null);
  const [limit, setLimit] = useState(1);
  const [blogsAndForumsFeedList, setBlogsAndForumsFeedList] =
    useState(EMPTY_ARRAY);
  const [hideShowMore, setHideShowMore] = useState(false);
  const [fromDate, setFromDate] = useState(def_fromDate);
  const [toDate, setToDate] = useState(def_toDate);
  const [channelType, setChannelType] = useState(
    SOCIAL_SOURCES_OPTIONS.map(({ id }) => id)
  );
  const [comments, setComments] = useState(def_comments_count);
  const [city, setCity] = useState(EMPTY_OBJECT);
  const [showImgViewer, setShowImgViewer] = useState(false);
  const [firstImageToShow, setFirstImageToShow] = useState(0);
  const [imgSrcArray, setImageSrcArray] = useState(EMPTY_ARRAY);
  const [selectCity, setSelectedCity] = useState(def_city);
  const [reaction, setReaction] = useState(def_reaction_count);
  const [tonality, setTonality] = useState(def_tonality);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [activeKey, setActiveKey] = useState(-1);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedFeedsGroup, setSelectedFeedsGroup] = useState([]);
  const [updatedBulkSentiment, setUpdatedBulkSentiment] = useState("");
  const [updatedBulkFavourite, setUpdatedBulkFavourite] = useState(false);
  const [showAddTagListModal, setShowAddTagListModal] = useState(false);
  const [isFavouriteChecked, setIsFavouriteChecked] = useState(false);
  const [vertical, setVertical] = useState("");
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedType, setSelectedType] = useState(undefined);
  const [selectedTaglist, setSelectedTaglist] = useState([]);
  const isSocialDownloading = getCookie(COOKIE.IS_SOCIAL_DOWNLOADING);
  const isPrintDownloading = getCookie(COOKIE.IS_PRINT_DOWNLOADING);
  const isBlogDownloading = getCookie(COOKIE.IS_BLOG_DOWNLOADING);
  const [showList, setShowList] = useState(true);
  const DownloadSuccess = getCookie(COOKIE.DOWNLOAD_SUCCESS);
  const [popup, setPopup] = useState(false);
  const [headline, setHeadline] = useState("");
  const [keyword, setKeyword] = useState("");
  const [downloadreportList, setDownloadreportList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");

  // const [tagsApplied, setTagsApplied]= useState(false)

  const entityState = useSelector(
    (state) => state.entityAndKeyWordsReducer || {}
  );
  const { socialEntityList } = entityState || [];
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const clientState = useSelector((state) => state.clientReducer) || {};

  // useEffect(() => {
  //   fetchCity();
  // }, EMPTY_ARRAY);

  useEffect(() => {
    if (DownloadSuccess === "true") {
      setPopup(DownloadSuccess === "true");
    }
    setTimeout(() => {
      setCookie({
        key: COOKIE.DOWNLOAD_SUCCESS,
        value: false,
      });
      setPopup(false);
    }, 5000);
  }, [DownloadSuccess]);

  useEffect(() => {
    if (socialEntityList) {
      const entIdList = socialEntityList.map((e) => e && e.id);
      setSelectedTopics(entIdList);
    }
  }, [socialEntityList]);

  useEffect(() => {
    if (updatedBulkSentiment) {
      setTimeout(() => {
        setSelectedFeeds([]);
        setSelectedFeedsGroup([]);
      }, 100);
    }
  }, [updatedBulkSentiment]);

  useEffect(() => {
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
  }, [updatedBulkFavourite]);

  const showLoader = isLoading;
  const showNoDataMessage = !showLoader && !blogsAndForumsFeedList.length;
  const showData = !showLoader && !showNoDataMessage;
  const progressPopup = (open) => {
    setShowList(open);
  };
  const isDownloading =
    isPrintDownloading == "true" ||
    isSocialDownloading == "true" ||
    isBlogDownloading == "true";

  const getDownloadReport = () => {
    setIsLoading(true);
    const payload = {
      client_id: `${selectedClient.id}`,
      year: selectedMonth.slice(0, 4),
      month: selectedMonth.slice(5, 7),
    };
    const client_id = selectedClient && selectedClient.id;
    let url = envConfig.DOWNLOAD_REPORTS;
    httpPost(url, payload).then((res) => {
      const { result } = res.data;
      setDownloadreportList(result);
      setIsLoading(false);
    });
  };
  return (
    <>
      {showAddTagListModal ? (
        <TagsListModal
          show={showAddTagListModal}
          onCancel={() => setShowAddTagListModal(false)}
          //   onBulkUpdate={handleTagsBulkUpdate}
        />
      ) : null}
      <div
        className={
          !!selectedFeeds.length
            ? "mainContainer socialContainer blogsForumContainer feedsSelected"
            : "mainContainer socialContainer blogsForumContainer"
        }
      >
        {showLoader && <GifLoader />}
        <div className="dashboardHeader dashboardHeading">
          <div className="dashboardHeaderTop d-flex">
            <div className="dashboardMobileMenu">
              <button className="btn menuBtn" id="menuBtn">
                <MenuIcon />
              </button>
              <img src={ConceptLogo} width="32" height="32" />
            </div>
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap d-flex align-items-center">
                <h1>Download Reports</h1>
              </div>
              {/* {popup && (
                <div className={styles.downloadLabel}>
                  <DownLoadSuccess />
                  <h3>Report download completed successfully !</h3>
                </div>
              )} */}
            </div>
          </div>
          <div className="topFilterWrap">
            <div className="mobTopHeading">
              <h1>Download Reports</h1>
            </div>
            <div className="titleRow blogsForumTitleRow">
              <div className="titleLeftWrap">
                <div className="filterWrap">
                  <DateRangeFilter
                    key="social-feed"
                    setSelectedMonth={setSelectedMonth}
                    selectedMonth={selectedMonth}
                    endRange={toDate}
                    // handleDateChange={handleDateChange}
                    // showShortCutk
                    minDate={selectedClient ? selectedClient.start_date : null}
                    maxDate={selectedClient ? selectedClient.end_date : null}
                    isDownloadreport
                  />
                  {/* {<DatePicker oneTap format="yyyy-MM" />} */}
                  {/* <DateRangeFilter /> */}
                  <button
                    className="btn btnBlue"
                    onClick={() => getDownloadReport()}
                  >
                    Submit
                  </button>
                </div>
              </div>
              {/* <div className="rightBtnContainer">
                <p className="col-md-6 text-right success-msg">
                  Report download Successfully !
                </p>
              </div> */}
            </div>
          </div>
        </div>
        {/* {downloadreportList && downloadreportList.length && (
          <div ref={listContainerRef} className="accordion accordionListWrap">
            {downloadreportList.map((singleReport, index) => {
              const data = {
                entityName: singleReport.name,
                url: singleReport.file_path,
                DownloadreportData: singleReport,
              };
              return (
                <TopicWiseNewsContainer
                  listContainerRef={listContainerRef}
                  listkey={index + 1}
                  entityFeeds={data}
                  activeKey={activeKey}
                  setActiveKey={setActiveKey}
                  selectedFeeds={selectedFeeds}
                  selectedFeedsGroup={selectedFeedsGroup}
                  setSelectedFeedsGroup={setSelectedFeedsGroup}
                  updatedBulkSentiment={updatedBulkSentiment}
                  updatedBulkFavourite={updatedBulkFavourite}
                  isDownloadreport
                  toDate={toDate}
                  fromDate={fromDate}
                  clientId={selectedClient.id}
                  setIsSelectAll={setIsSelectAll}
                  setSelectedType={setSelectedType}
                  // tagsApplied={tagsApplied}
                />
              );
            })}
          </div>
        )} */}
        {downloadreportList && downloadreportList.length && !showLoader ? (
          <div
            ref={listContainerRef}
            className="accordion accordionListWrap blogsForumsAccordionWrap"
          >
            {downloadreportList.map((report) => {
              return (
                <>
                  <div>
                    <li key={report.id}>
                      {report.name}
                      <a
                        href={`${report.file_path}/${report.file_name}`}
                        download
                      >
                        Download
                      </a>
                    </li>
                  </div>
                </>
              );
            })}
          </div>
        ) : (
          <NoDataMessage
            text="No Feeds Found"
            subtext="Try adjusting the filters to find what you’re looking for"
          />
        )}
        {/* Add div here */}
      </div>
    </>
  );
}

export default DownloadReports;
